import { IconButton, InputAdornment, TextField } from '@mui/material';
import Icon from 'components/icon2';
import React, { useState } from 'react';

interface Props {
  id?: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
  onBlur?: () => void;
}

export default function PasswordTextField({
  value,
  label,
  onChange,
  fullWidth = true,
  ...props
}: Props): JSX.Element {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      variant='standard'
      type={showPassword ? 'text' : 'password'}
      label={label}
      value={value}
      fullWidth={fullWidth}
      margin='normal'
      onChange={e => {
        onChange(e.target.value);
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              aria-label='toggle password visibility'
              onClick={() => setShowPassword(!showPassword)}
              edge='end'
              size='small'
              style={{ width: '2em' }}
            >
              <Icon icon={showPassword ? 'eye' : 'eye-slash'} />
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
}
